export default {
  title: '国家（地区）管理',

  // 搜索筛选区域
  search: {
    keyword: '关键词搜索',
    keywordPlaceholder: '国家名称、代码',
    continent: '大洲',
    continentPlaceholder: '选择大洲',
    status: '状态',
    statusPlaceholder: '选择状态',
    enabled: '启用',
    disabled: '禁用',
    searchButton: '搜索',
    resetButton: '重置'
  },

  // 操作按钮
  actions: {
    addCountryRegion: '新增国家地区',
    batchEnable: '批量启用',
    batchDisable: '批量禁用',
    enableItem: '启用',
    disableItem: '禁用',
    recordsCount: '共 {count} 条记录'
  },

  // 表格列
  table: {
    nameEn: '英文名',
    nameCn: '中文名',
    code: '代码',
    continent: '大洲',
    areaCode: '区号',
    status: '状态',
    operation: '操作'
  },

  // 关联弹窗
  modal: {
    title: '选择国家（地区）',
    confirmText: '确认添加 ({count})',
    selected: '已选择 {count} 个国家（地区），共 {total} 个可选'
  },

  // 确认对话框
  confirm: {
    enableItem: '确定要启用此国家（地区）吗？',
    disableItem: '确定要禁用此国家（地区）吗？',
    batchEnable: '确定要启用选中的 {count} 个国家（地区）吗？',
    batchDisable: '确定要禁用选中的 {count} 个国家（地区）吗？'
  },

  // 表单验证
  validation: {
    selectItems: '请选择要关联的国家（地区）'
  },

  // 消息提示
  messages: {
    selectToEnable: '请选择要启用的国家（地区）',
    selectToDisable: '请选择要禁用的国家（地区）',
    selectToAssociate: '请选择要关联的国家（地区）',
    loadError: '国家（地区）数据加载失败，请稍后重试',
    platformLoadError: '平台国家（地区）数据加载失败，请稍后重试',
    continentLoadError: '大洲数据加载失败，请稍后重试',
    associateError: '关联国家（地区）失败，请稍后重试',
    associateSuccess: '成功关联 {count} 个国家（地区）',
    statusToggleError: '状态切换失败，请稍后重试',
    statusToggleSuccess: '国家（地区）状态切换成功',
    batchEnableError: '批量启用失败，请稍后重试',
    batchEnableSuccess: '已启用 {count} 个国家（地区）',
    batchDisableError: '批量禁用失败，请稍后重试',
    batchDisableSuccess: '已禁用 {count} 个国家（地区）'
  },

  // 状态文本
  statusText: {
    enabled: '启用',
    disabled: '禁用'
  },

  // 大洲名称
  continents: {
    asia: '亚洲',
    europe: '欧洲',
    africa: '非洲',
    northAmerica: '北美洲',
    southAmerica: '南美洲',
    oceania: '大洋洲',
    antarctica: '南极洲'
  }
}